import { getStoredState } from 'redux-persist';

export default async (config) => {
  return getStoredState(config);
};
